import icLayers from "@iconify/icons-ic/twotone-layers";
import icContactSupport from "@iconify/icons-ic/twotone-contact-support";
import icDateRange from "@iconify/icons-ic/twotone-date-range";
import icChat from "@iconify/icons-ic/twotone-chat";
import icContacts from "@iconify/icons-ic/twotone-contacts";
import icAssessment from "@iconify/icons-ic/twotone-assessment";
import icLock from "@iconify/icons-ic/twotone-lock";
import icWatchLater from "@iconify/icons-ic/twotone-watch-later";
import icError from "@iconify/icons-ic/twotone-error";
import icAttachMoney from "@iconify/icons-ic/twotone-attach-money";
import icPersonOutline from "@iconify/icons-ic/twotone-person-outline";
import icReceipt from "@iconify/icons-ic/twotone-receipt";
import icHelp from "@iconify/icons-ic/twotone-help";
import icBook from "@iconify/icons-ic/twotone-book";
import icBubbleChart from "@iconify/icons-ic/twotone-bubble-chart";
import icFormatColorText from "@iconify/icons-ic/twotone-format-color-text";
import icStar from "@iconify/icons-ic/twotone-star";
import icViewCompact from "@iconify/icons-ic/twotone-view-compact";
import icPictureInPicture from "@iconify/icons-ic/twotone-picture-in-picture";
import icSettings from "@iconify/icons-ic/twotone-settings";
import icChromeReaderMode from "@iconify/icons-ic/twotone-chrome-reader-mode";
import { NavigationService } from "src/@vex/services/navigation.service";
import { TokenService } from "./token.service";
import { Injectable } from "@angular/core";

@Injectable()
export class MenuService {
  private appMenu:any = [
    {
      code: 1,
      route: "/empresas/cadastro",
    },
    {
      code: 2,
      route: "/empresas/listagem",
    },
    {
      code: 3,
      type: "link",
      route: "/equipamento/cadastro",
    },
    {
      code: 4,
      route: "/equipamento/lista",
    },
    {
      code: 5,
      route: "/equipamento/tipo",
    },
    {
      code: 6,
      route: "/ui/forms/tecnicos",
    },
    {
      code: 7,
      route: "/makers",
    },
    {
      code: 8,
      route: "/ui/forms/usuarios",
    },
    {
      code: 9,
      route: "/ui/forms/permissao",
    },
    {
      code: 10,
      route: "/service/ordemservico",
    },
    {
      code: 11,
      route: "/service/monitoramento",
    },
    {
      code: 12,
      route: "/os/laudos",
    },
    {
      code: 13,
      route: "/inspection",
    },
  ];

  private iconsGroup: any = [
    { icon: icChromeReaderMode, code: 1 },
    { icon: icSettings, code: 2 },
    { icon: icContactSupport, code: 3 },
    { icon: icLock, code: 4 },
    { icon: icReceipt, code: 5 },
  ];

  constructor(
    private navigationService : NavigationService,
    private tokenService: TokenService
    ){}

  getMenu(role) {
    const dash = {
      type: "link",
      label: "Dashboard",
      route: "/",
      icon: icLayers,
      routerLinkActiveOptions: { exact: true },
    };

    let menu = this.getStructMenu(role);

    menu.unshift(dash);

    return menu;
  }

  /**
   *
   */
  getStructMenu(role) {
    role.map((module) => {
      module.type = "subheading";
      module.label = module.modules_name;
      module.groups.map((group) => {
        group.type = "dropdown";
        group.label = group.group_name;
        const gIcon = this.iconsGroup.find(
          g => g.code == group.group_id
        );
        group.icon = gIcon.icon;
        group.permissions.map((permission) => {
          const routePermission = this.appMenu.find(
            (menu) => menu.code == permission.permission_id
          );

          permission.label = permission.permission_name;
          permission.type = "link";
          permission.route = routePermission.route;
          return permission;
        });
        group.children = group.permissions;
        return group;
      });
      module.children = module.groups;
      return module;
    });

    return role;
  }

  setMenuItems() {
    /**
     * Add your own routes here
     */
     const role = this.tokenService.getRole();
     if(role) {
       this.navigationService.items = this.getMenu(role);
     }
  }
}
